{
  "popup_modal": {
    "title": {
      "validate": "Validation",
      "warning": "Attention",
      "alert": "Avertissement"
    },
    "validate": "Valider",
    "cancel": "Annuler"
  },
  "breadcrumbs": {
    "contract_management": {
      "management": "Gestion",
      "signature": "Signature",
      "deposit_management": "Dépôt"
    }
  }
}
